const FINGERPRINT_KEY = "light-fingerprint";

let cached: string | null = null;

export function getFingerprint(): string {
  if (cached) return cached;

  // Keep API session/configuration fingerprinting independent of analytics.
  // PostHog may initialize or rotate its anonymous id after boot, which can
  // otherwise cause multiple fingerprints during a single embedded flow load.
  try {
    const stored = localStorage.getItem(FINGERPRINT_KEY);
    if (stored) {
      cached = stored;
      return cached;
    }
    const id = crypto.randomUUID();
    localStorage.setItem(FINGERPRINT_KEY, id);
    cached = id;
    return cached;
  } catch {
    // localStorage unavailable (e.g. blocked in iframe, private browsing)
    cached = crypto.randomUUID();
    return cached;
  }
}
